import { createAction, createActions } from 'redux-actions';

export const moduleName = 'userServices';

export const USER_SERVICES_LOAD_REQUESTED = `${moduleName}/USER_SERVICES_LOAD_REQUESTED`;
export const USER_SERVICES_LOAD_SUCCEEDED = `${moduleName}/USER_SERVICES_LOAD_SUCCEEDED`;
export const USER_SERVICES_LOAD_FAILED = `${moduleName}/USER_SERVICES_LOAD_FAILED`;

export const loadUserServicesRequest = createAction(USER_SERVICES_LOAD_REQUESTED);

export const {
  userServices: {
    userServicesLoadSucceeded: loadUserServicesSuccess,
    userServicesLoadFailed: loadUserServicesFailure,
  },
} = createActions({
  [USER_SERVICES_LOAD_SUCCEEDED]: payload => payload,
  [USER_SERVICES_LOAD_FAILED]: payload => payload,
});
